import { types, applySnapshot } from 'mobx-state-tree';
import Framework from '@greenville/framework';
import * as constants from '../../../common/constants';

const bookTitleData = types.model('bookTitleData', {
  id: types.maybeNull(types.string),
  title: types.maybeNull(types.string),
  bookId: types.maybeNull(types.string)
});

const GetBookTitlesDataModel = types
  .model('GetBookTitlesDataModel', {
    data: types.maybeNull(types.array(bookTitleData), [])
  })
  .actions((self) => ({
    fetch(payload) {
      Framework.getEventManager().publish(constants.FETCH_BOOK_TITLES_DATA, {
        payload
      });
    },
    setResponse(response) {
      const bookList = response?.data?.data || [];
      applySnapshot(self, { data: bookList });
      Framework.getEventManager().publish(constants.SET_BOOK_TITLES_DATA);
    },
    resetStoreValues() {
      applySnapshot(self, { data: [] });
      Framework.getEventManager().publish(constants.SET_BOOK_TITLES_DATA);
    }
  }));

export default GetBookTitlesDataModel;
